import { Box, Typography, Slider } from "@mui/material";
import { useRecoilState } from "recoil";
import {
    imageScaleAtom,
} from "../state";

const ImageSizeSlider = () => {
  const [imageScale, setImageScale] = useRecoilState(imageScaleAtom);

  return (
    <Box sx={{ marginRight:"3%", marginLeft:"20%" }}>
        <Typography id="input-slider" display="flex" justifyContent="flex-start">Image Size</Typography>
        <Slider
            data-testid="image-size-slider"
            size="small"
            defaultValue={100}
            aria-label="Small"
            valueLabelDisplay="auto"
            aria-labelledby="input-slider"
            onChange={(event) => setImageScale(event.target.value)}
            value={imageScale}
        />
    </Box>
  );
};

export default ImageSizeSlider;